// Real data for Carol Mezher's Portfolio from CV

export const profileData = {
  name: "Carol Mezher",
  roles: ["Film & TV Development", "Creative Direction", "Storytelling", "Content Curation", "Production"],
  tagline: "Multidisciplinary Content Director & Creative Producer shaping projects\nfrom concept to audience across film, media, and live experiences.",
  bio: "As a multilingual and transversal professional with extensive experience in film, TV, and cultural entertainment, I combine creative vision with hands-on production expertise. My work spans project development, international coordination, and high-stakes event management—from leading development at Cinemoz Media Group to directing industry events at Red Sea International Film Festival and producing large-scale ceremonies for UEFA, FIFA, and national celebrations.",
  expertise: [
    "Film & TV Development & Production",
    "Content Creation & Writing",
    "Event Production & Management",
    "Creative Direction & Strategy",
    "International Festival Programming",
    "Brand Storytelling & Experiences"
  ],
  email: "mezhercarol@gmail.com",
  phone: "+33 7 64 76 69 33",
  location: "Paris, France",
  linkedin: "https://www.linkedin.com/in/carol-mezher/",
  showreelUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ" // Placeholder
};

export const projects = [
  // Film & TV
  {
    id: 2,
    title: "ANOTHER DAY SHALL COME",
    subtitle: "World Premiere at Hot Docs 2026",
    category: "Films & TV Series",
    status: "Completed",
    year: "2026",
    runtime: "19 min",
    genre: "Short, Documentary Essay",
    language: "Arabic",
    countries: "Palestine, Qatar, Lebanon, France",
    supportedBy: "Supported by: Mawred Cultural Resource, AFAC, Doha Film Institute",
    director: "Written and directed by Aida Kaadan",
    role: "Executive Producer",
    company: "Palestine / Qatar / Lebanon / France",
    pressKit: "/assets/portfolio/ntf6e2fk_ADSC_by_Aida_Kaadan_EPK_2026.pdf",
    letterboxdUrl: "https://letterboxd.com/film/another-day-shall-come/",
    description: "An audio-visual portrait of stifled Palestinians living in 48' borders during Israel's ongoing genocide in Gaza. It features a collection of anonymous voices, weaved into scenes shot in historical Palestine, encapsulating 76 years of identity deprivation and alienation.",
    highlights: [
      "Hot Docs International Documentary Festival 2026 (Canada) / World Premiere",
      "Visions du Réel Market 2026 (Switzerland)",
      "Cannes Film Festival 2026 - Marché du Film - Producer's Network / Palestinian Pavilion Showcase (France)",
      "Anafi International Film Festival 2026 (Greece)",
      "Palm Springs International ShortFest 2026 (USA)",
      "BlackStar Film Festival 2026 (USA)"
    ],
    image: "/assets/portfolio/fmozs3xz_Another_Day_Shall_Come.png",
    pressMentions: [
      {
        publication: "Al Araby TV",
        title: "Interview & Coverage",
        date: "May 2026",
        url: "https://www.youtube.com/watch?v=eKfdTkPJlkE"
      },
      {
        publication: "L'Orient-Le Jour",
        title: "Press Coverage",
        date: "May 2026",
        url: "https://drive.google.com/file/d/1f41OT8G_Kh1EDU2R0PXlwPa25S895Jo7/view"
      },
      {
        publication: "Monte Carlo Doualiya",
        title: "Café Show",
        date: "May 2026",
        url: "https://www.mc-doualiya.com/%D8%A8%D8%B1%D8%A7%D9%85%D8%AC/%D9%83%D8%A7%D9%81%D9%8A%D9%87-%D8%B4%D9%88/20260502-%D8%B9%D8%A7%D9%8A%D8%AF%D8%A9-%D9%82%D8%B9%D8%AF%D8%A7%D9%86-%D8%AA%D9%88%D8%AB%D9%91%D9%82-%D8%B5%D9%85%D8%AA-%D8%A7%D9%84%D9%81%D9%84%D8%B3%D8%B7%D9%8A%D9%86%D9%8A%D9%8A%D9%86-%D8%AF%D8%A7%D8%AE%D9%84-%D8%A7%D9%84%D8%AE%D8%B7-%D8%A7%D9%84%D8%A3%D8%AE%D8%B6%D8%B1?utm_slink=mc-d.co%2F2GO2"
      }
    ],
    tags: ["Documentary", "Executive Producer", "International Festivals", "Social Impact"]
  },
  {
    id: 1,
    title: "DEAD DOG",
    subtitle: "World Premiere at IFFR 2025\nBest Arab Film at Cairo International Film Festival 2025",
    category: "Films & TV Series",
    status: "Completed",
    year: "2025",
    runtime: "92 min",
    format: "Feature, Fiction",
    genre: "Drama",
    language: "Lebanese Arabic",
    countries: "Lebanon, France, Qatar, KSA",
    production: "Placeless Films (Lebanon), Dewberries Films (France)",
    supportedBy: "Supported by: Doha Film Institute, Organisation Internationale de la Francophonie, Red Sea Fund",
    worldSales: "World Sales: MAD World",
    director: "Written and directed by Sarah Francis",
    role: "Associate Producer",
    company: "Placeless Films & Dewberries Films",
    pressKit: "/assets/portfolio/q93zke02_Dead_Dog_press-kit_En_(3).pdf",
    letterboxdUrl: "https://letterboxd.com/film/dead-dog-2025/",
    imdbUrl: "https://www.imdb.com/title/tt35625052/?ref_=ttfc_ov_bk",
    description: "On a rainy evening, Aida drives up to the Lebanese mountains and unlocks an empty family house. Only Walid, her husband, who has been living abroad for years, is not expecting to find her there. Temporarily reunited in the same space, they face the status of their lives together and apart. Is there anything left to be saved? Dead Dog is a measured dissection of a marriage that is simultaneously breathing and decomposing.",
    highlights: [
      "International Film Festival Rotterdam 2025 – World Premiere (Harbour section)",
      "Sarajevo Film Festival 2025 – screened in the Partner Presents programme (Doha Film Institute)",
      "Mostra Internacional de Cinema em São Paulo 2025 – International Perspective section",
      "Festival Internacional de Cine de la Provincia de Buenos Aires (FICPBA) 2025 - International Feature Film Competition",
      "Cairo International Film Festival 2025 – Horizons of Arab Cinema Competition; Best Arab Film award",
      "Festival du film libanais de France 2025 – French Avant-Première",
      "Bengaluru International Film Festival 2026 - World Cinema Section",
      "Beirut International Women Film Festival 2026 - Special Mention"
    ],
    pressMentions: [
      {
        publication: "The New Arab",
        title: "Exploring Love and Memory in Dead Dog",
        date: "December 2025",
        url: "https://www.newarab.com/features/exploring-love-and-memory-sarah-francis-dead-dog"
      },
      {
        publication: "L'Orient Le Jour",
        title: "Dead Dog and the Music of a Romance Gone Silent",
        date: "December 2025",
        url: "https://today.lorientlejour.com/article/1487437/dead-dog-and-the-music-of-a-romance-gone-silent.html"
      },
      {
        publication: "Variety",
        title: "Dead Dog Wins Best Arab Film at Cairo Film Festival",
        date: "November 2025",
        url: "https://variety.com/2025/film/global/dead-dog-sarah-francis-cairo-film-festival-chirine-karameh-1236589231/"
      },
      {
        publication: "The Hollywood Reporter",
        title: "Estranged Marriage Drama Dead Dog at IFFR 2025",
        date: "February 2025",
        url: "https://www.hollywoodreporter.com/movies/movie-news/dead-dog-film-estranged-marriage-lebanon-iffr-2025-1236118990/"
      },
      {
        publication: "Deadline",
        title: "MAD World Sales on Lebanese Couple Drama Dead Dog",
        date: "January 2025",
        url: "https://deadline.com/2025/01/mad-world-sales-lebanese-couple-drama-dead-dog-rotterdam-1236272684/"
      }
    ],
    image: "/assets/portfolio/m74ixjzv_Dead_Dog.jpg",
    tags: ["Feature Film", "Associate Producer", "International Festivals", "Award Winner"]
  },
  {
    id: 21,
    title: "LE JOUR DU SEIGNEUR",
    subtitle: "Live Broadcast from Beirut",
    category: "Films & TV Series",
    status: "Completed",
    year: "2022",
    format: "TV Program, Hybrid Live Broadcast & Documentary",
    broadcaster: "France 2",
    languages: "French, Arabic",
    production: "France TV Studios & CFRT",
    coproduction: "Bande à Part Productions (Lebanon) & Dewberries Films (France)",
    role: "Line Producer & Production Manager",
    company: "France TV Studios, CFRT, Bande à Part Productions",
    description: "A special edition of France 2's Sunday program spotlighting the aftermath of the Beirut port explosion and Lebanon's economic crisis, featuring a hybrid live broadcast mass from Beirut and a pre-recorded segment filmed across the country to highlight affected communities.",
    highlights: [
      "Combined a live mass from Beirut with a locally shot documentary-style segment",
      "Broadcast on France 2 (October 2, 2022)",
      "Reached 713,000 viewers and 10.9% market share in France",
      "Filmed on location in Beirut, Lebanon"
    ],
    image: "/assets/portfolio/s1jombzd_Screenshot_97.jpg"
  },
  {
    id: 3,
    title: "PALMYRA",
    subtitle: "Fiction Series - Advanced Development",
    category: "Films & TV Series",
    status: "In Development",
    year: "Advanced Development",
    format: "Episodic / 6 x 50 Min",
    genre: "Dramatic Thriller, Art Heist, True Events",
    languages: "Arabic, English, French, Danish",
    countries: "Lebanon, France, Qatar",
    supportedBy: "Supported by: Doha Film Institute",
    director: "Co-created by Carol Mezher & Gabriela Flores",
    role: "Lead Writer & Showrunner",
    company: "Lebanon / France / Qatar",
    trailerLink: "https://app.frame.io/presentations/7392e8ea-519d-4b8d-9731-80a3423ec2db",
    description: "Upon the brutal murder of Palmyra's head of antiquities, three women—a thriving art gallerist, a struggling hotelier, and a young archaeologist—are pulled together as the sole inheritors of precious artifacts he smuggled from the ancient Syrian city, under harrowing circumstances. But as they battle to safeguard the treasures in their custody, they find themselves entangled in a worldwide art intrigue, confronting them with menacing buyers and long-buried family secrets.",
    highlights: [
      "Doha Film Fund - Development Grant 2024",
      "Doha Film Institute - Series Lab Alumni 2024",
      "MIA Market - Drama Co-Production Pitching Forum 2024",
      "Doha Film Institute - Qumra Participant 2025"
    ],
    pressMentions: [
      {
        publication: "Cineuropa",
        title: "Qumra 2025 Programme Announced",
        date: "April 2025",
        url: "https://cineuropa.org/en/newsdetail/476235/"
      },
      {
        publication: "Deadline",
        title: "Qumra 2025 Projects",
        date: "March 2025",
        url: "https://deadline.com/2025/03/qumra-2025-projects-doha-film-institute-1236311424/"
      },
      {
        publication: "Screen Daily",
        title: "Among Qumra 2025 Projects",
        date: "January 2025",
        url: "https://www.screendaily.com/news/palestinian-sci-fi-in-memory-of-times-to-come-among-qumra-2025-projects/5202657.article"
      },
      {
        publication: "Deadline",
        title: "MIA Market Co-Production & Pitching Forum Selection",
        date: "September 2024",
        url: "https://deadline.com/2024/09/mia-market-co-production-market-pitching-forum-selection-1236093997/"
      },
      {
        publication: "Screen Daily",
        title: "Doha Film Institute Unveils 44 Projects for 2024 Spring Grants",
        date: "May 2024",
        url: "https://www.screendaily.com/news/doha-film-institute-unveils-44-projects-for-2024-spring-grants-at-cannes/5193648.article"
      },
      {
        publication: "Cineuropa",
        title: "Doha Film Institute Spring Grants 2024",
        date: "May 2024",
        url: "https://cineuropa.org/en/newsdetail/474717"
      }
    ],
    image: "/assets/portfolio/t3vkp9x5_Palmyra.jpg",
    tags: ["Series Development", "Writer", "Showrunner", "Art Heist", "International Co-Production"]
  },
  {
    id: 5,
    title: "TWO BIRDS, ONE STONE",
    subtitle: "Fiction Short - Financing",
    category: "Films & TV Series",
    status: "Financing",
    year: "Financing",
    format: "Short, Fiction",
    genre: "Drama, Family Feud",
    languages: "Lebanese Arabic",
    countries: "Lebanon, France",
    coproduction: "Co-produced with: BTRSWT Pictures (Lebanon)",
    director: "Written and directed by Chérine Karam",
    role: "Executive Producer",
    company: "BTRSWT Pictures, Lebanon / France",
    description: "On a hunting trip in the Lebanese mountains, Imad offers to buy his brother Sami's share of their inherited family house, sparking a heated confrontation.",
    highlights: [
      "Tripoli Film Industry Days - Arab Shorts Pitching Platform 2024 - Winner 1st Prize"
    ],
    image: "/assets/portfolio/h3zgmisv_Two_Birds_One_Stone.png",
    tags: ["Short Film", "Executive Producer", "Award Winner", "Co-Production"]
  },
  
  // Other Projects (In Development)
  {
    id: 6,
    title: "Cinemoz Studios Development Slate",
    subtitle: "Line Up - In Development",
    category: "Films & TV Series",
    status: "In Development - Other Projects",
    year: "In Development",
    role: "Development Executive & Associate Producer",
    company: "Cinemoz Media Group",
    developmentSlate: "/assets/portfolio/ha1hw4fv_Cinemoz_Studios_The_Project_DEVELOPMENT_LINEUP_2024.pdf",
    description: "An exclusive line-up of original titles at the crossroads of Middle Eastern storytelling and Global audiences.",
    fullDescription: "Drove the development and international positioning of a slate of film and TV projects at the crossroads of Middle Eastern storytelling and global audiences, including 3 TV series, 9 feature films, and 2 documentaries. Oversaw projects from script development and financing through to market and festival presentation, in collaboration with creative teams and international partners.",
    highlights: [
      "3 TV Series in development",
      "9 Feature Films in development",
      "2 Documentaries in development",
      "Script development and international positioning",
      "Market and festival presentation strategy",
      "Collaboration with creative teams and global partners"
    ],
    image: "/assets/portfolio/3urrwpiw_Cinemoz_Studios_The_Project_DEVELOPMENT_LINEUP_2024_copy.jpg",
    tags: ["Development", "TV Series", "Feature Films", "Documentaries", "International Co-Production"]
  },

  
  // International Film Festivals & Industry Programs
  {
    id: 7,
    title: "Doha Film Festival",
    subtitle: "Supporting emerging talent internationally",
    category: "Industry & Cultural Programming",
    year: "2025",
    role: "Jury Programme Senior International Coordinator",
    company: "Doha Film Institute, Doha",
    description: "The Doha Film Institute's Doha Film Festival 2025 (DFF) is a major international film platform bringing together global cinema, industry dialogue, and youth engagement programmes. It continues the Institute's mission of fostering cultural exchange through curated screenings, talent development initiatives, and community-focused jury experiences across multiple festival sections.",
    highlights: [
      "International programme featuring curated films across competition and non-competition sections",
      "Youth Jury and education-focused initiatives, including workshops, talks, and interactive learning hubs",
      "Industry programming such as panels, guest sessions, and networking events with global filmmakers",
      "Spotlight on regional talent through Made in Qatar and related development platforms",
      "Expanded audience engagement through screenings, Q&As, and community-driven festival activities"
    ],
    slideshow: [
      { image: "/assets/portfolio/3ie86e63_DFF_1.png" },
      { image: "/assets/portfolio/pnp6xq16_DFF_2.jpg" },
      { image: "/assets/portfolio/q7c1hkqz_DFF_3.jpg" },
      { image: "/assets/portfolio/4s8umocu_DFF_4.jpeg" },
      { image: "/assets/portfolio/7bd2crk6_DFF_5.jpg" },
      { image: "/assets/portfolio/hqarx5bc_DFF_6.jpg" },
      { image: "/assets/portfolio/i16p7uic_DFF_7.jpg" },
      { image: "/assets/portfolio/r10f2zt6_DFF_8.jpg" },
      { image: "/assets/portfolio/3a3tujdr_DFF_9.jpg" },
      { image: "/assets/portfolio/m6r07lbx_DFF_10.jpg" },
      { image: "/assets/portfolio/e3sbalm9_DFF_11.jpg" },
      { image: "/assets/portfolio/7trvky52_DFF_12.jpg" },
      { image: "/assets/portfolio/5lfdg6e2_DFF_13.jpg" },
      { image: "/assets/portfolio/f4g70l6j_DFF_14.jpeg" }
    ],
    responsibilities: "Managed jury program delivery, including film preparation, lesson plans, screenings, Q&As, and moderator coordination across festival sections. Coordinated cross-team workflows (programming, production, guest relations, marketing) to deliver schedules, jury materials, talks, and industry sessions for Made in Qatar Shabab. Supported development and execution of workshops, panels, publications, and jury engagement activities, ensuring smooth on-ground festival operations.",
    responsibilitiesLinks: [
      { label: "View Doha Film Festival", url: "https://www.youtube.com/playlist?list=PLS-AleRU6knd0Az5JVedKKM10874IOzL0", colorClass: "bg-whale-blue hover:bg-whale-blue/92" },
      { label: "View Ajyal Show", url: "https://www.youtube.com/playlist?list=PLLFXC6I6J6J9O2DV3CxG7YoD7vfkK01fk", colorClass: "bg-midnight-blue hover:bg-midnight-blue/90" }
    ],
    image: "/assets/portfolio/3ie86e63_DFF_1.png",
    video: "/assets/portfolio/2qmh7m97_DFF_2025.mp4",
    producerLogo: "/assets/portfolio/w52kqur8_Doha_Film_Institute_logo.png",
    producerWebsite: "https://www.dohafilm.com/en",
    producerLogoLabel: "Organized by"
  },
  {
    id: 8,
    title: "Ajyal Film Festival",
    subtitle: "Engaging young generations through cinema",
    category: "Industry & Cultural Programming",
    year: "2024",
    role: "Jury Programme International Senior Coordinator",
    company: "Doha Film Institute, Doha",
    description: "Ajyal Film Festival is an annual youth-focused cinema festival that celebrates the power of storytelling, creativity, and cultural exchange through international cinema, organized by the Doha Film Institute. For 12 years, Ajyal operated as a standalone festival before coming under the umbrella of the Doha Film Festival. Bringing together filmmakers, young jurors, and global audiences, the festival is known for its strong community-driven approach, empowering young people to engage critically with films while fostering dialogue, empathy, and artistic expression.",
    highlights: [
      "The 12th edition of the festival was held from 16–23 November 2024 across multiple venues in Doha.",
      "The 2024 theme, \"Moments That Matter,\" focused on stories of resilience, compassion, and human connection.",
      "The festival showcased 66–71 films from over 38–42 countries, including feature films, documentaries, and shorts.",
      "Special programmes included \"Voices from Palestine\" and \"Intaj: From Ground Zero Experience,\" highlighting stories of resistance, identity, and lived experiences from the region.",
      "Ajyal continued its signature Youth Jury Programme, engaging hundreds of young jurors aged 8–25 from diverse backgrounds, including participants from Gaza.",
      "The festival featured Made in Qatar and the newly introduced Made in Qatar Shabab programme, showcasing emerging local filmmakers and homegrown talent.",
      "Additional events included Ajyal Talks, Geekend pop-culture activities, open-air screenings, and inclusive screenings, reinforcing the festival's commitment to accessibility and community engagement."
    ],
    responsibilities: "Coordinated the Ajyal Jury Programme and Made in Qatar Shabab, overseeing jury activities, film Q&As, panels, and interactive festival experiences. Collaborated across programming, production, marketing, and guest relations teams to deliver schedules, moderator materials, and audience engagement initiatives. Curated educational and creative content for young jurors, including lesson plans, journals, hub activities, and industry discussions.",
    responsibilitiesLinks: [
      { label: "View Ajyal Film Festival", url: "https://www.youtube.com/playlist?list=PLLFXC6I6J6J_OveQmbKw2BNc6XkEADrrW", colorClass: "bg-whale-blue hover:bg-whale-blue/92" },
      { label: "View Ajyal Show", url: "https://www.youtube.com/@AjyalFilm", colorClass: "bg-midnight-blue hover:bg-midnight-blue/90" }
    ],
    slideshow: [
      { image: "/assets/portfolio/wm3u0lhy_Ajyal_1.jpg" },
      { image: "/assets/portfolio/wnrf5wr3_Ajyal_2.jpeg" },
      { image: "/assets/portfolio/5ue1d6ot_Ajyal_3.jpeg" },
      { image: "/assets/portfolio/w356y3e1_Ajyal_4.JPG" },
      { image: "/assets/portfolio/acflgusj_Ajyal_5.jpg" },
      { image: "/assets/portfolio/u9xgvzqw_Ajyal_7.JPG" },
      { image: "/assets/portfolio/zl0swm2h_Ajyal_8.JPG" },
      { image: "/assets/portfolio/0o1iwx1o_Ajyal_9.jpg" },
      { image: "/assets/portfolio/d636wm8o_Ajyal_10.jpg" },
      { image: "/assets/portfolio/cgo8atv7_Ajyal_11.jpg" },
      { image: "/assets/portfolio/hrmwu6dk_Ajyal_12.jpg" },
      { image: "/assets/portfolio/pa2zxryu_Ajyal_13.jpg" },
      { image: "/assets/portfolio/31uu8s5a_Ajyal_14.jpg" },
      { image: "/assets/portfolio/8u3pry3q_Ajyal_15.JPG" },
      { image: "/assets/portfolio/3g2lttqi_Ajyal_16.jpg" },
      { image: "/assets/portfolio/suuaai0o_Ajyal_17.jpg" },
      { image: "/assets/portfolio/vdnjyim1_Ajyal_18.jpg" },
      { image: "/assets/portfolio/vk3by6l1_Ajyal_19.JPG" },
      { image: "/assets/portfolio/7yi5e95n_Ajyal_20.jpg" }
    ],
    image: "/assets/portfolio/0hy9jpkk_Ajyal_FilM_Festival.jpg",
    video: "/assets/portfolio/qh3vru9l_Ajyal_Film_Festival__Filmmakers_in_Qatar_showcase_their_stories.mp4",
    producerLogo: "/assets/portfolio/w52kqur8_Doha_Film_Institute_logo.png",
    producerWebsite: "https://www.dohafilm.com/en",
    producerLogoLabel: "Organized by"
  },
  {
    id: 16,
    title: "Red Sea International Film Festival\n/ Red Sea Souk",
    subtitle: "Bridging regional cinema and the global industry",
    category: "Industry & Cultural Programming",
    year: "2022-2023",
    role: "Head of Industry Events\nRed Sea 360° and Networking Sessions Manager",
    company: "Red Sea Film Foundation, Jeddah",
    soukDescription: "The Red Sea Souk is the industry arm of the Red Sea International Film Festival, held annually in Jeddah, Saudi Arabia. It brings together regional and international film and TV professionals through project pitches, industry talks, talent labs, and networking sessions, fostering market insights, project development, and cross-border collaborations.",
    description: "Across its 2022 and 2023 editions, contributed to the Souk's programming, overseeing industry talks and networking sessions, and supporting connections between filmmakers, talent, and international partners.",
    redSea360Link: "https://redseafilmfest.com/en/red-sea-360/",
    redSea360Highlights: [
      "Curated 15 industry sessions over 4 days featuring 60+ influential speakers from the Arab, African, Asian, European, and American film and TV industries",
      "Covered trends, market insights, and future directions for Arab, African, and Asian cinema",
      "Explored the global influence of regional film industries and provided actionable insights for producers, distributors, and content creators",
      "Strengthened the international visibility and reach of Arab, African, and Asian cinema"
    ],
    redSea2023Highlights: [
      {
        image: "/assets/portfolio/y5ph4bge_1_Writers_Journey36.jpg",
        title: "The Writer's Journey: Navigating Scripts for Film, TV, and Future Storytelling Formats"
      },
      {
        image: "/assets/portfolio/475s7b3m_2_Womens_Panel.JPG",
        title: "Women Charting the Course of Film & TV: Crafting Unconventional Narratives"
      },
      {
        image: "/assets/portfolio/aa307ze7_3_Film_Franchise_and_IP.JPG",
        title: "Film Franchise & IP in Contemporary Cinema: Impact on Talent, Industry, and Culture"
      },
      {
        image: "/assets/portfolio/h1hze5kh_4_Series.png",
        title: "Peak TV's Season Finale: Too Little or Too Many Series?"
      },
      {
        image: "/assets/portfolio/zadkcp3x_5_Blockchain_.jpg",
        title: "Is the Blockchain Still an Opportunity for the Film Industry?"
      },
      {
        image: "/assets/portfolio/gt2jjv4c_6_MUBI.jpg",
        title: "No Bad Films Ever. The Story of MUBI"
      },
      {
        image: "/assets/portfolio/b7bjd7mz_7_Collaborative_Ventures.JPG",
        title: "Collaborative Ventures: Adapting International IPs; Investing in Local Productions; Connecting Local Stories to Global Audiences"
      },
      {
        image: "/assets/portfolio/0kcwomeb_8_Cinematic_Crossovers.JPG",
        title: "Cinematic Crossovers: Exploring the Global Impact of Hallyuwood, Bollywood, Nollywood, and French Cinema"
      },
      {
        image: "/assets/portfolio/1z14jl4j_9_Coproduction_Opportunities.JPG",
        title: "Unlocking Coproduction Opportunities with the Arab World; Scanning the Ecosystem of Film Commissions, Funds, Labs, and Filming Locations"
      },
      {
        image: "/assets/portfolio/ztr1b8a5_10_Variety_Award_Show_Kaouther_Ben_Hania.jpg",
        title: "Variety International Filmmaker Award: In Conversation with Kaouther Ben Hania"
      }
    ],
    networkingLink: "https://redseafilmfest.com/en/souk-networking-sessions/",
    networkingHighlights: [
      "Hosted 120+ film and TV professionals in structured, speed-dating networking sessions",
      "Facilitated connections between festival attendees and international industry leaders",
      "Enabled cross-border collaborations, partnerships, and co-productions, fostering long-term industry relationships"
    ],
    networking2023Highlights: [
      {
        image: "/assets/portfolio/f10kikdy_Networking_Sessions_2023_1.jpg",
        title: "Networking Sessions 2023"
      },
      {
        image: "/assets/portfolio/4z74voew_Networking_Sessions_2023_2.jpg",
        title: "Networking Sessions 2023"
      },
      {
        image: "/assets/portfolio/27j4nkrx_Networking_Sessions_2023_4.jpg",
        title: "Networking Sessions 2023"
      },
      {
        image: "/assets/portfolio/xv8vjbet_Networking_Sessions_2023_5.jpg",
        title: "Networking Sessions 2023"
      },
      {
        image: "/assets/portfolio/mx7r2xaa_Networking_Sessions_2023_6.jpg",
        title: "Networking Sessions 2023"
      },
      {
        image: "/assets/portfolio/r2qenhko_Networking_Sessions_2022_1.jpg",
        title: "Networking Sessions 2022"
      },
      {
        image: "/assets/portfolio/2gh9e7k6_Networking_Sessions_2022_2.png",
        title: "Networking Sessions 2022"
      },
      {
        image: "/assets/portfolio/0lea1198_Networking_Sessions_2022_3.png",
        title: "Networking Sessions 2022"
      }
    ],
    pressMentions: [
      {
        publication: "Variety",
        title: "Saudi Arabia, India, South Korea Partner at Red Sea",
        date: "December 2023",
        url: "https://variety.com/2023/film/global/saudi-arabia-india-south-korea-red-sea-1235823955/"
      },
      {
        publication: "Variety",
        title: "Combating Stereotypes of Arab and Muslim Characters",
        date: "December 2023",
        url: "https://variety.com/2023/film/global/arab-muslim-characters-red-sea-1235818619/"
      },
      {
        publication: "The Hollywood Reporter",
        title: "AI, Stereotypes and Peak TV at Red Sea Film Festival",
        date: "December 2023",
        url: "https://www.hollywoodreporter.com/business/business-news/ai-stereotypes-peak-tv-red-sea-film-festival-1235708651/"
      },
      {
        publication: "The Hollywood Reporter Italia",
        title: "Fine della Peak TV, AI e Stereotipi al Red Sea Fest Market",
        date: "December 2023",
        url: "https://www.hollywoodreporter.it/industry/mercati/fine-della-peak-tv-ai-e-stereotipi-i-temi-scottanti-affrontati-al-panel-del-red-sea-fest-market/71167/"
      },
      {
        publication: "The Hollywood Reporter",
        title: "WME Independent Theatrical at Red Sea Film Festival",
        date: "December 2023",
        url: "https://www.hollywoodreporter.com/movies/movie-news/wme-independent-theatrical-red-sea-film-festival-1235705447/"
      },
      {
        publication: "Deadline",
        title: "Barunson Film AlUla: Bollywood, Nollywood, Hallyuwood at Red Sea",
        date: "December 2023",
        url: "https://deadline.com/2023/12/barunson-film-alula-bollywood-nollywood-hallyuwood-red-sea-film-festival-1235652369/"
      },
      {
        publication: "Deadline",
        title: "IMAX and Arab Films: Oppenheimer at Red Sea",
        date: "December 2023",
        url: "https://deadline.com/2023/12/imax-arab-films-oppenheimer-christopher-nolan-red-sea-1235649555/"
      }
    ],
    video: "/assets/portfolio/e7ciby4o_4148257464e843d5b6c686ae6faf9cbf.MP4",
    image: "/assets/portfolio/fyv7qjha_Red_Sea_International_FilM_Festival.png",
    producerLogo: "/assets/portfolio/dumbmq1u_Red_Sea.jpeg",
    producerWebsite: "https://redseafilmfest.com/en/",
    producerLogoLabel: "Organized by"
  },
  {
    id: 9,
    title: "Lebanese Film Festival",
    subtitle: "Showcasing Lebanese cinema",
    category: "Industry & Cultural Programming",
    year: "2012-2018",
    role: "General Coordinator & Producer (2012–2014–2018)",
    company: "Bande à Part Productions & Né à Beyrouth Films, Beirut",
    description: "The Lebanese Film Festival was a Beirut-based film platform founded in 2001, dedicated to showcasing Lebanese cinema and strengthening its connection with international film culture. It provided a space for filmmakers to present their work, meet audiences, and engage with industry professionals, while promoting Lebanese cinematic creation locally and abroad.\n\nThe festival combined screenings with competitive sections and industry-focused activities, including awards for fiction, documentary, first films, and experimental works. It also fostered exchange between filmmakers, producers, critics, and international guests through curated programs, retrospectives, and thematic focuses that highlight both Lebanese and global cinema.",
    highlights: [
      "Strengthened the festival structure and curated growing editions focused on Lebanese auteur cinema and emerging voices",
      "Co-created the first edition of the Beirut Cinema Project (BCP), a pioneering co-production platform supporting project development and international collaboration (in partnership with Fondation Liban Cinéma)",
      "Introduced and developed special thematic programming and country-focused showcases, including the first Argentine Film Week in Beirut",
      "Contributed to establishing the festival as a key meeting point for Lebanese filmmakers and international industry professionals, reinforcing its role as a national hub for independent cinema and talent discovery",
      "Hosted leading figures of cinema and culture, including Nadine Labaki, Ibrahim Maalouf, and Jocelyne Saab",
      "Produced by: Bande à Part Productions & Né à Beyrouth Films"
    ],
    responsibilities: "Co-led festival direction, programming strategy, and production across multiple editions, curating dozens of films each year across fiction, documentary, and experimental formats. Worked with hundreds of Lebanese and international filmmakers through screenings, panels, and industry events. Oversaw guest curation, partnerships, logistics, and communications, acting also as spokesperson for press and institutional relations.",
    slideshow: [
      { video: "/videos/lff_trailer_2012.mp4", title: "Lebanese Film Festival 2012" },
      { image: "/assets/portfolio/6ja7c0od_LFF_2012_1.JPG", title: "Lebanese Film Festival 2012" },
      { image: "/assets/portfolio/fv2m9yw2_LFF_2012_2.jpg", title: "Lebanese Film Festival 2012" },
      { image: "/assets/portfolio/bjlej1rx_LFF_2012_3.jpg", title: "Lebanese Film Festival 2012" },
      { image: "/assets/portfolio/0tnhnwcn_LFF_2012_4.JPG", title: "Lebanese Film Festival 2012" },
      { image: "/assets/portfolio/sdjuvrsw_LFF_2012_5.JPG", title: "Lebanese Film Festival 2012" },
      { image: "/assets/portfolio/ygnrls5m_LFF_2012_6.JPG", title: "Lebanese Film Festival 2012" },
      { image: "/assets/portfolio/ipzq03b9_LFF_2012_7.JPG", title: "Lebanese Film Festival 2012" },
      { video: "/videos/lff_trailer_2014.mp4", title: "Lebanese Film Festival 2014" },
      { image: "/assets/portfolio/pfuoz16t_LFF_2014_1.JPG", title: "Lebanese Film Festival 2014" },
      { image: "/assets/portfolio/n53jle0k_LFF_2014_2.jpg", title: "Lebanese Film Festival 2014" },
      { image: "/assets/portfolio/wo8g6rda_LFF_2014_3.jpg", title: "Lebanese Film Festival 2014" },
      { image: "/assets/portfolio/30pl0osd_LFF_2018_1.JPG", title: "Lebanese Film Festival 2018" },
      { image: "/assets/portfolio/1zggdfqt_LFF_2018_2.JPG", title: "Lebanese Film Festival 2018" },
      { image: "/assets/portfolio/z1yp8jhu_LFF_2018_3.JPG", title: "Lebanese Film Festival 2018" }
    ],
    image: "/assets/portfolio/pfuoz16t_LFF_2014_1.JPG",
    video: "/videos/lff_hero.mp4",
    tags: ["Festival Direction", "Programming", "Co-production Market"]
  },
  {
    id: 10,
    title: "FFFMed Screenwriting Residency",
    subtitle: "Empowering Mediterranean Women Storytellers",
    category: "Industry & Cultural Programming",
    year: "2018-2020",
    role: "Founder & Producer",
    company: "Bande à Part Productions, Beirut",
    description: "Films Femmes Francophones | Méditerranée (FFFMed) was a screenwriting residency supporting emerging French-speaking women filmmakers from the Mediterranean region and its diaspora. The program provided mentorship, professional workshops, and networking opportunities to help participants develop feature film projects in an intercultural creative environment. Two editions have been organized to date: 2018 in Lebanon and 2020 online, with partnerships including Organisation internationale de la Francophonie, Institut français, Air France, and TV5Monde. The initiative promoted new female voices in cinema while fostering long-term international collaborations and co-production opportunities.",
    highlights: [
      "International screenwriting residency created by Bande à Part Productions to support emerging French-speaking women filmmakers from the Mediterranean region and its diaspora",
      "One-week intensive program combining personalized mentorship, collective workshops, pitching sessions, masterclasses, and networking with film industry professionals",
      "Mission focused on promoting women's voices in cinema, intercultural dialogue, and francophone collaboration across the Mediterranean",
      "Objectives include fostering new talent, enabling international co-productions, and positioning Lebanon as a filmmaking and cultural hub",
      "First edition held in Lebanon in partnership with the Lebanese Film Festival and the Institut français",
      "2018 open call attracted 38 candidates from 10 Mediterranean countries, with strong international and multicultural representation",
      "Long-term follow-up included festival participation, development grants, Cannes pitching opportunities, and co-production support for selected projects",
      "Supported by leading international partners and media organizations including Organisation internationale de la Francophonie, Air France, BBC Arabic, and TV5Monde"
    ],
    responsibilities: "Created and produced two editions in Lebanon (2018) and online (2020). Managed partnerships, funding, international talent selection, program development, communications, logistics, and festival representation, while building long-term networking and co-production opportunities with major cultural and media institutions.",
    slideshow: [
      { image: "/assets/portfolio/qg0flpvn_0.jpg" },
      { image: "/assets/portfolio/t6ldtgay_1.jpeg" },
      { image: "/assets/portfolio/hpijddt0_2.JPG" },
      { image: "/assets/portfolio/f1ive0oe_4.JPG" },
      { image: "/assets/portfolio/pi08xjnp_5.JPG" },
      { image: "/assets/portfolio/924x1m4q_6.JPG" },
      { image: "/assets/portfolio/yt8zl0ep_7.JPG" },
      { image: "/assets/portfolio/w4hiof5l_8.jpg" },
      { image: "/assets/portfolio/ieps3e76_9.jpg" },
      { image: "/assets/portfolio/yhwtfu3b_11.jpeg" },
      { image: "/assets/portfolio/l9tj05dq_12.jpeg" },
      { image: "/assets/portfolio/re1yd3tl_13.jpeg" },
      { image: "/assets/portfolio/d8zvy1t6_14.jpeg" },
      { image: "/assets/portfolio/vb827hsd_15.jpg" },
      { image: "/assets/portfolio/chzqz090_16.jpg" },
      { image: "/assets/portfolio/06qzntfw_17.jpg" },
      { image: "/assets/portfolio/xntd3uzx_18.jpg" },
      { image: "/assets/portfolio/i94tu9sg_19.jpg" },
      { image: "/assets/portfolio/yz7nh6is_20.JPG" },
      { image: "/assets/portfolio/7gz6rgbl_21.JPG" },
      { image: "/assets/portfolio/wvdb4bm5_22.JPG" },
      { image: "/assets/portfolio/08t96lrm_23.jpeg" },
      { image: "/assets/portfolio/oi1kpyqc_24.jpeg" },
      { image: "/assets/portfolio/aj5dl3na_25.jpeg" }
    ],
    pressMentions: [
      {
        publication: "TV5 Monde",
        title: "Destination Francophonie",
        date: "TV Feature",
        url: "https://www.youtube.com/watch?v=Jt47rGxiaM0"
      },
      {
        publication: "BBC Arabic",
        title: "BBC Xtra",
        date: "TV Feature",
        url: "https://www.youtube.com/watch?v=oCgHRPXSBdY"
      },
      {
        publication: "MTV Lebanon",
        title: "FFFMed Feature",
        date: "TV Feature",
        url: "https://www.youtube.com/watch?v=mL2JEvu80CI"
      },
      {
        publication: "Radio Liban",
        title: "Interview with Nanette Ziadé",
        date: "Radio Interview",
        url: "https://soundcloud.com/user-74704618/interview-avec-nanette-ziade-radio-liban"
      },
      {
        publication: "Le Français dans le Monde",
        title: "Le français rassemble",
        date: "October 2018",
        url: "https://www.fdlm.org/blog/2018/10/19/le-francais-rassemble/"
      },
      {
        publication: "L'Orient-Le Jour",
        title: "Le cinéma au Liban, une affaire de femmes",
        date: "September 2018",
        url: "https://www.lorientlejour.com/article/1134110/le-cinema-au-liban-une-affaire-de-femmes.html"
      }
    ],
    catalogs: [
      { label: "View Catalog 2018", url: "https://drive.google.com/file/d/14bSsrSSo0WfSdP5cTHgfEo-JfsnsCIy9/view" },
      { label: "View Catalog 2020", url: "https://drive.google.com/file/d/1HY7M2TPhgKEWioSX-GF1AOEu541Fwwf4/view" }
    ],
    image: "/assets/portfolio/s8wyaknk_FFFMED.jpg",
    video: "/videos/fffmed_hero.mp4",
    tags: ["Program Development", "Screenwriting", "International Partnerships"]
  },
  
  // Sports Ceremonies
  {
    id: 11,
    title: "UEFA Champions League Final 2016\nOpening Ceremony",
    subtitle: "San Siro Stadium, Milan (Italy)",
    category: "Sports Ceremonies",
    year: "2016",
    role: "Junior Artistic Producer & Assistant Creative Director",
    company: "Filmmaster Events, Milan",
    description: "A high-impact opening ceremony transforming the stage at San Siro Stadium, featuring headline performances by Alicia Keys and Andrea Bocelli.",
    fullDescription: "Conceived as a high-impact live experience, the opening ceremony of the UEFA Champions League Final 2016 transformed the pitch of San Siro Stadium into a dynamic stage ahead of Europe's most anticipated match. Blending large-scale choreography, scenography, and live performance, it culminated in a headline performance by Alicia Keys alongside Andrea Bocelli.",
    highlights: [
      "Global broadcast reaching 380 million viewers across 200+ countries",
      "Delivered a 10-minute live ceremony ahead of the final match on May 28th, 2016",
      "342 performers across 23 nationalities",
      "4 weeks / 73 hours of rehearsals and large-scale casting process",
      "342 costumes and full performer styling teams",
      "Complex staging including a 7,500 sqm pitch protection carpet",
      "Live performance by Alicia Keys and Andrea Bocelli",
      "350+ staff and volunteers, including stagehands and protocol teams"
    ],
    responsibilities: "Acted as right hand to the Creative Director and Artistic Producer, ensuring seamless execution of the creative vision. Coordinated show concept, artist integration, talent casting, costume production, music rehearsals, choreography, stage design, lighting, pyro, and TIFO production with suppliers. Supported show calling, backstage operations, and liaised with creative teams, client, and suppliers. Collaborated with broadcast directors on live TV storyboards, advising on camera positions, and oversaw stadium visuals and communication assets.",
    image: "/assets/portfolio/2ezl60h2_UEFA_Champions_League_Final.jpg",
    video: "https://pub-d65ba4feb3ca45ff9b059c10f9c86f37.r2.dev/hebfau8v_UEFA_Champions_League_Final_2016_V2.mov",
    slideshow: [
      {
        image: "/assets/portfolio/nalxchdk_20160528_UEFA_CL_Milan_Final_ANovelli-09011.jpg",
      },
      {
        image: "/assets/portfolio/u1l6bo49_20160528_UEFA_CL_Milan_Final_ANovelli-09020.jpg",
      },
      {
        image: "/assets/portfolio/bnu1xmo1_20160528_UEFA_CL_Milan_Final_ANovelli-09028.jpg",
      },
      {
        image: "/assets/portfolio/70esbn3r_20160528_UEFA_CL_Milan_Final_ANovelli-09558.jpg",
      },
      {
        image: "/assets/portfolio/9npvoujq_20160528_UEFA_CL_Milan_Final_ANovelli-09567.jpg",
      },
      {
        image: "/assets/portfolio/hvnozmyb_20160528_UEFA_CL_Milan_Final_ANovelli-09579.jpg",
      },
      {
        image: "/assets/portfolio/owm5logi_20160528_UEFA_CL_Milan_Final_ANovelli-09585.jpg",
      },
      {
        image: "/assets/portfolio/cyrs3mp9_20160528_UEFA_CL_Milan_Final_ANovelli-09587.jpg",
      },
      {
        image: "/assets/portfolio/snnftprb_20160528_UEFA_CL_Milan_Final_ANovelli-09590.jpg",
      },
      {
        image: "/assets/portfolio/jc1wtgc7_20160528_UEFA_CL_Milan_Final_ANovelli-09594.jpg",
      },
      {
        image: "/assets/portfolio/xkjv49f3_20160528_UEFA_CL_Milan_Final_ANovelli-09601.jpg",
      },
      {
        image: "/assets/portfolio/zl0rdi07_20160528_UEFA_CL_Milan_Final_ANovelli-09605.jpg",
      },
      {
        image: "/assets/portfolio/qy83sh04_20160528_UEFA_CL_Milan_Final_ANovelli-09613.jpg",
      },
      {
        image: "/assets/portfolio/be0km1ge_20160528_UEFA_CL_Milan_Final_ANovelli-09619.jpg",
      },
      {
        image: "/assets/portfolio/70nezlk1_20160528_UEFA_CL_Milan_Final_ANovelli-09625.jpg",
      }
    ],
    producerLogo: "/assets/portfolio/30ntmuvi_LOGO_FILMMASTER.svg",
    producerWebsite: "https://www.filmmaster.com/en"
  },
  {
    id: 12,
    title: "UEFA Euro 2016\nOpening Ceremony",
    subtitle: "Stade de France, Saint-Denis (France)",
    category: "Sports Ceremonies",
    year: "2016",
    role: "Junior Artistic Producer & Assistant Creative Director",
    company: "Filmmaster Events, Paris",
    description: "A globally broadcast stadium spectacle celebrating French culture through the concept of \"Joie de Vivre\", featuring a headline performance by David Guetta and Zara Larsson.",
    fullDescription: "The opening ceremony of UEFA Euro 2016 was conceived as a globally broadcast stadium spectacle celebrating French culture through the concept of \"Joie de Vivre.\" Combining large-scale scenography, choreography, and live music, the show unfolded as a vibrant, festive tribute to French identity, culminating in a headline performance by David Guetta alongside Zara Larsson.",
    highlights: [
      "Global broadcast reaching 130M+ TV viewers and 80,000+ live spectators",
      "Performed on June 10, 2016 at Stade de France ahead of the opening match",
      "Award-winning ceremony (Bea Italia – Best Sporting Event, EUBEA – 2nd Prize Best Sport Event)",
      "400+ performers embodying iconic French cultural symbols",
      "Large-scale stage design including a 7,500 sqm French garden, carousel, and 36m Eiffel Tower",
      "144 cancan dancers featured in mass choreography sequences",
      "Headline performance by David Guetta and Zara Larsson, featuring the official UEFA anthem",
      "60 musicians from the Garde Républicaine alongside 60 singers from the Maîtrise de Radio France",
      "100 audience leaders for TIFO activation",
      "Grand finale with aerial tricolor display and stadium-wide audience choreography"
    ],
    responsibilities: "Acted as right hand to the Creative Director and Artistic Producer, ensuring seamless execution of the creative vision. Coordinated show concept, artist integration, talent casting, costume production, music rehearsals, choreography, stage design, lighting, pyro, and TIFO production with suppliers. Oversaw the production of segments featuring the French Republican Guard and the Choir School of Radio France. Supported show calling and backstage operations, liaised with creative teams, client, and suppliers, and collaborated with broadcast directors on live TV storyboards, advising on camera positions. Oversaw stadium visuals and communication assets.",
    video: "https://pub-d65ba4feb3ca45ff9b059c10f9c86f37.r2.dev/hidpf42p_UEFA_Euro_2016_Opening_Ceremony.mov",
    slideshow: [
      {
        image: "/assets/portfolio/z57096lc_euro_OC_1.jpg",
      },
      {
        image: "/assets/portfolio/dsx2thkl_euro_OC_2.jpg",
      },
      {
        image: "/assets/portfolio/u4vgctqo_euro_OC_3.avif",
      },
      {
        image: "/assets/portfolio/mn05fi4g_euro_OC_4.jpg",
      },
      {
        image: "/assets/portfolio/sd5esn3u_euro_OC_5.jpg",
      },
      {
        image: "/assets/portfolio/099ud61l_euro_OC_6.jpg",
      },
      {
        image: "/assets/portfolio/ag5xuxow_euro_OC_7.jpg",
      },
      {
        image: "/assets/portfolio/o6zqjldu_euro_OC_8.jpeg",
      },
      {
        image: "/assets/portfolio/g95f7iry_euro_OC_9.jpg",
      },
      {
        image: "/assets/portfolio/z7les5v7_euro_OC_10.jpg",
      },
      {
        image: "/assets/portfolio/gpkvc0jr_euro_OC_11.jpg",
      },
      {
        image: "/assets/portfolio/mpvmabiv_euro_OC_12.jpg",
      },
      {
        image: "/assets/portfolio/dadzpxoc_euro_OC_13.jpeg",
      },
      {
        image: "/assets/portfolio/vmj89r3m_euro_OC_14.jpeg",
      }
    ],
    producerLogo: "/assets/portfolio/30ntmuvi_LOGO_FILMMASTER.svg",
    producerWebsite: "https://www.filmmaster.com/en",
    collaborationLogo: "/assets/portfolio/r7wvy5ko_Bakuza_Logo.svg",
    collaborationWebsite: "https://bakuza.com/",
    image: "/assets/portfolio/dyglhro4_UEFA_Euro_2016_Opening_Ceremony.jpg"
  },
  {
    id: 13,
    title: "UEFA Euro 2016 Final\nClosing Ceremony",
    subtitle: "Stade de France, Saint-Denis (France)",
    category: "Sports Ceremonies",
    year: "2016",
    role: "Junior Artistic Producer & Assistant Creative Director",
    company: "Filmmaster Events, Paris",
    description: "A large-scale live spectacle designed as a high-energy \"EURO Symphony\" that brought together international artists, orchestras, and hundreds of performers ahead of the final match.",
    fullDescription: "The closing ceremony of UEFA Euro 2016 was conceived as a large-scale live spectacle celebrating the tournament's finale through music, mass choreography, and stadium-wide audience interaction. Designed as a high-energy \"EURO Symphony,\" the show brought together international artists, orchestras, and hundreds of performers, culminating in a final live performance of the official anthem by David Guetta and Zara Larsson ahead of the final match.",
    highlights: [
      "Global broadcast reaching millions of viewers worldwide",
      "Performed on July 10th, 2016 at Stade de France ahead of the final match",
      "Large-scale \"EURO Symphony\" concept blending live music and mass choreography",
      "480+ dancers and 200+ musicians integrated into the performance",
      "Participation of the Musique des Sapeurs-Pompiers de Paris and the Garde Républicaine",
      "Final live performance of the official UEFA anthem by David Guetta & Zara Larsson",
      "Stadium-wide audience choreography and TIFO activation",
      "Live orchestral reinterpretation of iconic tracks, including \"Seven Nation Army\""
    ],
    responsibilities: "Acted as right hand to the Creative Director and Artistic Producer, ensuring seamless execution of the creative vision. Coordinated show concept, artist integration, talent casting, costume production, music rehearsals, choreography, stage design, lighting, pyro, and TIFO production with suppliers. Oversaw the production of segments featuring the French Republican Guard and the Paris Fire Brigade. Supported show calling and backstage operations, liaised with creative teams, client, and suppliers, and collaborated with broadcast directors on live TV storyboards, advising on camera positions. Oversaw stadium visuals and communication assets.",
    slideshow: [
      {
        image: "/assets/portfolio/28wkli5y_CC2.jpg",
      },
      {
        image: "/assets/portfolio/rqrq5dx5_CC3.jpg",
      },
      {
        image: "/assets/portfolio/kwtrbwvf_CC4.jpg",
      },
      {
        image: "/assets/portfolio/37f2ja8l_CC5.jpg",
      },
      {
        image: "/assets/portfolio/qwpcxh6f_CC6.jpg",
      },
      {
        image: "/assets/portfolio/265jydfu_CC7.jpeg",
      }
    ],
    video: "https://pub-d65ba4feb3ca45ff9b059c10f9c86f37.r2.dev/zc2lxxhf_UEFA_Euro_2016_Closing_Ceremony.mp4",
    producerLogo: "/assets/portfolio/30ntmuvi_LOGO_FILMMASTER.svg",
    producerWebsite: "https://www.filmmaster.com/en",
    collaborationLogo: "/assets/portfolio/r7wvy5ko_Bakuza_Logo.svg",
    collaborationWebsite: "https://bakuza.com/",
    image: "/assets/portfolio/ixgfledi_UEFA_Euro_2016_Closing_Ceremony.jpeg"
  },
  {
    id: 14,
    title: "UEFA Women Champions League Final 2016 Opening Ceremony",
    subtitle: "Mapei Stadium – Città del Tricolore, Reggio Emilia (Italy)",
    category: "Sports Ceremonies",
    year: "2016",
    role: "Junior Artistic Producer & Assistant Creative Director",
    company: "Filmmaster Events, Reggio Emilia",
    description: "The opening ceremony of the UEFA Women's Champions League Final 2016 was conceived as a live stadium experience blending choreography, music, and visual storytelling ahead of the final match.",
    highlights: [
      "Live pre-match ceremony for a major European final",
      "Choreographed performance integrated with stadium scenography",
      "Fusion of music, dance, and visual design",
      "Included a children mass choir recording as part of the musical composition"
    ],
    responsibilities: "Acted as right hand to the Creative Director and Artistic Producer, ensuring seamless execution of the creative vision. Coordinated show concept, artist integration, talent casting, costume production, music rehearsals, choreography, and stage design. Supported show calling, backstage operations, and liaised with creative teams, client, and suppliers.",
    producerLogo: "/assets/portfolio/30ntmuvi_LOGO_FILMMASTER.svg",
    producerWebsite: "https://www.filmmaster.com/en",
    image: "/assets/portfolio/oyubo0iv_UEFA_Women_Champions_League_Final.jpg"
  },
  {
    id: 15,
    title: "Khalifa Stadium Inauguration\nOpening Ceremony",
    subtitle: "Doha (Qatar)",
    category: "Sports Ceremonies",
    year: "2017",
    role: "Artistic Coordinator & Music Producer",
    company: "Doha",
    description: "The show was conceived as a large-scale live spectacle celebrating Qatar's sporting legacy and future. Blending projection mapping, orchestral music, and stadium-scale scenography, it marked the unveiling of the first venue for the FIFA World Cup 2022.",
    highlights: [
      "Took place on May 19, 2017 in Doha, Qatar",
      "15-minute live ceremony combining visual and musical storytelling",
      "Large-scale projection mapping integrated across the stadium",
      "Narrative structured in three acts celebrating Qatar's past, present, and future",
      "Official inauguration of the first completed stadium for the 2022 FIFA World Cup",
      "Grand finale featuring ribbon-cutting and large-scale fireworks display"
    ],
    responsibilities: "Coordinated artistic production and music development, liaising between creative teams, composers, and performers to ensure cohesive execution. Oversaw music production, including recordings and integration with live performance, while supporting overall show coordination across staging, choreography, and flow.",
    producerLogo: "/assets/portfolio/30ntmuvi_LOGO_FILMMASTER.svg",
    producerWebsite: "https://www.filmmaster.com/en",
    image: "/assets/portfolio/wvwf1imy_20211028_1635429546-202-1.jpeg"
  },
  {
    id: 18,
    title: "UAE's 45th National Day Ceremony",
    subtitle: "Tribute to 45 Years of UAE Nationhood",
    category: "National Celebrations",
    year: "2016",
    role: "Assistant Artistic Producer & Scenic Producer",
    company: "Balich Wonder Studio, Abu Dhabi",
    description: "A large-scale live performance for the 45th UAE National Day, celebrating the nation's history, identity, and future vision. Built around the concept of Amanah—a powerful symbol of trust, unity, and legacy—the ceremony paid tribute to the UAE's founding values, from its cultural roots to the leadership of Sheikh Zayed, through a visually immersive and emotionally driven spectacle.",
    highlights: [
      "Tribute to 45 years of UAE nationhood and unification, held on December 2nd, 2016 in Abu Dhabi",
      "Large-scale live performance for dignitaries and official audience",
      "Monumental set design structures up to 300m long × 35m high",
      "Multiple scenic installations including 8m and 16m large-scale builds",
      "6,500 sqm of immersive video projection surfaces",
      "1000-soldier military parade",
      "Multi-act storytelling blending history, culture, and future vision",
      "High-end production combining scenography, projection, and live performance"
    ],
    producerLogo: "/assets/portfolio/xup3xoa1_LOGO_BWS.png",
    producerWebsite: "https://www.balichwonderstudio.com/",
    image: "/assets/portfolio/m4j8gyz7_15.jpg",
    video: "https://pub-d65ba4feb3ca45ff9b059c10f9c86f37.r2.dev/axyybf82_UAE_45th_National_Day_Ceremony.mp4",
    slideshow: [
      {
        image: "/assets/portfolio/zjqb6hmv_1.jpg",
      },
      {
        image: "/assets/portfolio/fcu19r8k_2.jpg",
      },
      {
        image: "/assets/portfolio/2izmsd4i_10.jpg",
      },
      {
        image: "/assets/portfolio/oydxg2a8_12.jpg",
      },
      {
        image: "/assets/portfolio/trhphan7_13.jpg",
      },
      {
        image: "/assets/portfolio/58e3b356_14.jpg",
      },
      {
        image: "/assets/portfolio/4lxb5fjj_15.jpg",
      },
      {
        image: "/assets/portfolio/lawito1d_16.jpg",
      },
      {
        image: "/assets/portfolio/hyfvgapj_17.jpg",
      },
      {
        image: "/assets/portfolio/97pgx7sf_3.jpg",
      },
      {
        image: "/assets/portfolio/cjzugsxw_9.jpg",
      },
      {
        image: "/assets/portfolio/a7n06prv_18.jpg",
      },
      {
        image: "/assets/portfolio/7qi1xbv4_20.jpg",
      },
      {
        image: "/assets/portfolio/8c33ltvr_21.jpg",
      }
    ],
    responsibilities: "Oversaw artistic production and scenic elements, coordinating creative teams and local suppliers while managing budgets and event guidelines. Supported film/video shoots, show calling, and the management of musical groups, talents, animals, and local performers for seamless execution.",
    tags: ["National Ceremony", "Artistic Production", "Talent Management", "Cultural Production"]
  },
  {
    id: 17,
    title: "KSA's 89th National Day Celebration",
    subtitle: "Inspiration Road",
    category: "National Celebrations",
    year: "2019",
    role: "Lead Writer & Editor, Video Producer",
    company: "Balich Wonder Studio, Riyadh",
    description: "A contemporary celebration of Saudi Arabia's heritage and vision, \"Inspiration Road\" showcased the Kingdom's past, present, and future through seven spectacular acts. The production blended traditional culture with modern artistic interpretations, featuring live performances, stunning visuals, and international talent to honor Saudi Arabia on its 89th National Day.",
    highlights: [
      "Saudi Arabia National Day celebrated on September 23, 2019 in Riyadh",
      "Over 230 performers and a 115-member international production team from 34 countries",
      "Included 38 Saudi talents highlighting local culture and artistry",
      "Seven acts blending tradition, modern choreography, opera, and multimedia storytelling",
      "Poetic and immersive representation of Saudi landscapes and history",
      "Modern reinterpretation of the traditional Samri dance",
      "Opera performance by Italian Mezzo-Soprano Mariangela De Vita"
    ],
    producerLogo: "/assets/portfolio/xup3xoa1_LOGO_BWS.png",
    producerWebsite: "https://www.balichwonderstudio.com/",
    collaborationLogo: "/assets/portfolio/zhs3vw00_Logo_Time.png",
    collaborationWebsite: "https://www.time-entertainment.com/",
    responsibilities: "Key member of the creative team. Curated the narrative creative process with the Creative Director, leading R&D, concept development, scriptwriting, editorial content, and strategy from pitch to execution. Conceived, wrote, and supervised all narrative and editorial content for live performance, film, and communications, and oversaw the production of all video content through post-production.",
    mediaGuide: "/assets/portfolio/qt0t6c6z_SND_PressKit_Eng.pdf",
    video: "/assets/portfolio/mh8pqyec_Saudi_89th_National_Day.mp4",
    image: "/assets/portfolio/z31gpc75_Inspiration_Road_23.jpg",
    slideshow: [
      {
        image: "/assets/portfolio/fp9befy3_Inspiration_Road_2.jpg",
      },
      {
        image: "/assets/portfolio/wszhb8zn_Inspiration_Road_3.jpg",
      },
      {
        image: "/assets/portfolio/2e3jnv5j_Inspiration_Road_5.jpg",
      },
      {
        image: "/assets/portfolio/ir73vvyj_Inspiration_Road_8.jpg",
      },
      {
        image: "/assets/portfolio/ife3i990_Inspiration_Road_19.jpg",
      },
      {
        image: "/assets/portfolio/zzkklosy_Inspiration_Road_20.jpg",
      },
      {
        image: "/assets/portfolio/762rdj7a_Inspiration_Road_22.jpg",
      },
      {
        image: "/assets/portfolio/z31gpc75_Inspiration_Road_23.jpg",
      },
      {
        image: "/assets/portfolio/luc3in4i_Inspiration_Road_25.jpg",
      },
      {
        image: "/assets/portfolio/gwbawbxo_Inspiration_Road_27.jpg",
      },
      {
        image: "/assets/portfolio/ff9qtvt8_Inspiration_Road_28.jpg",
      },
      {
        image: "/assets/portfolio/nan3jtt1_Inspiration_Road_29.jpg",
      },
      {
        image: "/assets/portfolio/009wmioh_Inspiration_Road_30.jpg",
      },
      {
        image: "/assets/portfolio/fvhxtygq_Inspiration_Road_31.jpg",
      },
      {
        image: "/assets/portfolio/ou6lwiep_Inspiration_Road_32.jpg",
      },
      {
        image: "/assets/portfolio/iwhxueit_Inspiration_Road_33.jpg",
      },
      {
        image: "/assets/portfolio/ua9my5yr_Inspiration_Road_35.jpg",
      },
      {
        image: "/assets/portfolio/42via8ji_Inspiration_Road_36.jpg",
      }
    ],
    tags: ["National Celebration", "Creative Writing", "Video Production", "Cultural Events"]
  },
  
  // Theatrical Shows
  {
    id: 20,
    title: "Leila, the Land of Imagination",
    subtitle: "Closing Show of the Riyadh Season 2020",
    category: "Theatrical Shows & Immersive Experiences",
    year: "2020",
    location: "King Fahd Stadium, Riyadh",
    producedBy: "Produced by Balich Wonder Studio",
    role: "Lead Writer & Editor, Video Producer",
    company: "Balich Wonder Studio KSA",
    mediaGuide: "/assets/portfolio/t9fae7gm_LEILA_Press_Kit_Jan2020.pdf",
    description: "A groundbreaking 90-minute theatrical production produced by Balich Wonder Studio, exploring Saudi Arabia's transformation through the journey of a 10-year-old girl, Leila. Moving across the country's diverse landscapes—from deserts and mountains to volcanic fields and coastal regions—the show reflects a new generation navigating a changing national context.",
    responsibilities: "Core member of the creative team, contributing to concept development and writing the show's narrative and full content from pitch to execution. Responsible for scriptwriting and editorial development across theatrical, video, and communication content, and overseeing film content production through post-production.",
    highlights: [
      "Grand finale of Riyadh Season, staged on January 16th, 2020",
      "Reached 9M+ online views",
      "Featured 598 Saudi and international performers, including 248 traditional local performers",
      "Included the first solo performance by a Saudi ballerina in Saudi Arabia",
      "600+ costumes and 250 props",
      "Performed at King Fahd Stadium (Riyadh)"
    ],
    producerLogo: "/assets/portfolio/xup3xoa1_LOGO_BWS.png",
    producerWebsite: "https://www.balichwonderstudio.com/",
    collaborationLogo: "/assets/portfolio/zhs3vw00_Logo_Time.png",
    collaborationWebsite: "https://www.time-entertainment.com/",
    slideshow: [
      {
        image: "/assets/portfolio/7ao5u5d9__MG_4439.jpg",
      },
      {
        image: "/assets/portfolio/focd6n6p__O2I2772.jpg",
      },
      {
        image: "/assets/portfolio/edtz6qgc__O2I3224.jpg",
      },
      {
        image: "/assets/portfolio/1bhpmzl6__O2I4301.jpg",
      },
      {
        image: "/assets/portfolio/8noi4ts8__O2I4683.jpg",
      },
      {
        image: "/assets/portfolio/makcwx53__F0T7535.jpg",
      },
      {
        image: "/assets/portfolio/luzem592__F0T7736.jpg",
      },
      {
        image: "/assets/portfolio/6h48kgah__F0T8079.jpg",
      },
      {
        image: "/assets/portfolio/90q9aj2a__F0T8163.jpg",
      },
      {
        image: "/assets/portfolio/6q7a12zv__F0T8189.jpg",
      },
      {
        image: "/assets/portfolio/leila-leila-land-of-imagination-riyadh-season-water-performers.webp",
      },
      {
        image: "/assets/portfolio/leila-leila-land-of-imagination-riyadh-season-white-horse.webp",
      },
      {
        image: "/assets/portfolio/leila-leila-land-of-imagination-riyadh-season-dancers.webp",
      },
      {
        image: "/assets/portfolio/leila-leila-land-of-imagination-riyadh-season-moon-baloon.webp",
      },
      {
        image: "/assets/portfolio/leila-leila-land-of-imagination-riyadh-season-pyro-show-king-fahd-stadium.webp",
      },
      {
        image: "/assets/portfolio/leila-leila-land-of-imagination-riyadh-season-performers.webp",
      },
      {
        image: "/assets/portfolio/leila-leila-land-of-imagination-riyadh-season-lavanda-fields.webp",
      },
      {
        image: "/assets/portfolio/leila-leila-land-of-imagination-riyadh-season-poetess-horse.webp",
      }
    ],
    pressMentions: [
      {
        publication: "TV5 Monde",
        title: "Maghreb-Orient Express",
        date: "January 2020",
        url: "https://www.youtube.com/watch?v=mQ4_RSgbAyk"
      },
      {
        publication: "LBCI",
        title: "Leila: Bringing Saudi Arabia's Vision 2030 to Life",
        date: "January 2020",
        url: "https://www.lbcgroup.tv/news/world/496200/%D9%81%D9%8A-%D8%A7%D8%B7%D8%A7%D8%B1-%D8%A7%D9%84%D8%B1%D8%A4%D9%8A%D8%A9-2030-%D8%A7%D9%84%D8%B3%D8%B9%D9%88%D8%AF%D9%8A%D8%A9-%D9%88%D8%B6%D8%B9%D8%AA-%D9%84%D9%86%D9%81%D8%B3%D9%87%D8%A7-%D9%87%D8%AF%D9%81%D8%A7/ar"
      }
    ],
    video: "/assets/portfolio/k8xpzesq_Leila,_the_Land_of_Imagination_Highlights.mp4",
    image: "/assets/portfolio/s46r8nip__MG_1445_LD.jpg"
  },
  {
    id: 19,
    title: "Regeneration",
    subtitle: "Aquarium of Genoa's 25th Anniversary",
    category: "Exhibitions & Immersive Experiences",
    year: "2016",
    role: "Junior Artistic Producer & Assistant Creative Director",
    company: "Filmmaster Events, Genoa",
    description: "\"Regeneration\" is an immersive edutainment experience created for the 25th anniversary of the Aquarium of Genoa, one of the largest aquariums in Europe. Built around the concept of the aquarium as a ship travelling across the world's seas, the project reimagined the visitor journey through storytelling, interactive environments, and a complete redesign of scenography, sound, and lighting.",
    fullDescription: "\"Regeneration\" is an immersive edutainment experience created for the 25th anniversary of the Aquarium of Genoa, one of the largest aquariums in Europe. Built around the concept of the aquarium as a ship travelling across the world's seas, the project reimagined the visitor journey through storytelling, interactive environments, and a complete redesign of scenography, sound, and lighting. A large-scale video mapping installation in the Sala Blu introduces visitors to the narrative, setting the tone for a cohesive and engaging exploration of marine ecosystems.",
    highlights: [
      "Immersive experience concept developed for the 25th anniversary of the Aquarium of Genoa",
      "Reimagined visitor journey through edutainment-driven storytelling",
      "Creation of interactive installations across the exhibition spaces",
      "Full redesign of scenography, sound, and lighting environments",
      "Signature video mapping installation in the Sala Blu introducing the experience",
      "Narrative concept: the aquarium as a ship travelling through the world's seas",
      "Seamless integration of education, entertainment, and spatial design",
      "One of Europe's largest aquariums transformed into an interactive storytelling environment"
    ],
    producerLogo: "/assets/portfolio/30ntmuvi_LOGO_FILMMASTER.svg",
    producerWebsite: "https://www.filmmaster.com/en",
    responsibilities: "Supported the artistic execution and implementation of an immersive experience inspired by a ship travelling across the world's seas. Contributed to the development of a 3D mapping installation at the exhibition's entrance, including storytelling, music, voice-over, and video projections.",
    video: "/assets/portfolio/8fo3jeqo_Acquario_di_Genova.mp4",
    image: "/assets/portfolio/2dshrwgl_acquariogenova_839d35_4ff6d8c261b94870af66365bab8b0af4mv2_d_3000_2000_s_2.jpg",
    slideshow: [
      {
        image: "/assets/portfolio/wk2tadir_acquariogenova_839d35_4ff6d8c261b94870af66365bab8b0af4mv2_d_3000_2000_s_2.jpg",
      },
      {
        image: "/assets/portfolio/xhno311v_acquariogenova_839d35_9a087e9da45a47999456c6b3d9f8b272mv2_d_3000_2000_s_2.webp",
      },
      {
        image: "/assets/portfolio/07z6zoqk_acquariogenova_839d35_988cf7d3bb864067af2d5ea6ac14f50amv2_d_3000_2000_s_2.jpg",
      },
      {
        image: "/assets/portfolio/ttryn8c4_acquariogenova_839d35_bba2ce91c8894f8084519daf8220a0famv2_d_3000_2000_s_2.jpg",
      },
      {
        image: "/assets/portfolio/0nvn50wm_acquariogenova_839d35_fad733fdb1834cffbdc39f068d35b274mv2_d_3000_2064_s_2.webp",
      }
    ]
  }
];

// Bridge sentence for services
export const servicesBridgeSentence = "Working across film, television, and large-scale live experiences, projects are developed with a unified narrative and audience strategy.";

export const services = [
  {
    title: "Narrative Development & Storytelling",
    subtitle: "Shaping stories from concept to execution",
    bullets: [
      "Concept creation & story development",
      "Pitch materials and financing dossiers",
      "Narrative strategy for cross-format projects",
      "Script doctoring and creative mentoring",
      "Talent scouting and creative team support"
    ]
  },
  {
    title: "Creative Production & Execution",
    subtitle: "Bringing stories to life across formats and scales",
    bullets: [
      "Creative direction and show design",
      "Production management and oversight",
      "Budget and logistics coordination",
      "Creative team leadership and delivery",
      "End-to-end project execution"
    ]
  },
  {
    title: "Audience Strategy & Programming",
    subtitle: "Designing how stories reach, engage, and resonate",
    bullets: [
      "Festival programming and content curation",
      "Industry talks and panel coordination",
      "Publications and editorial management",
      "Audience experience design for cultural programs",
      "Strategic positioning and distribution strategy"
    ]
  }
];

export const experience = [
  {
    id: 1,
    role: "Development Executive & Associate Producer",
    company: "Cinemoz Media Group",
    location: "Paris, Beirut",
    period: "2022 - Present",
    description: "Leading film and TV project development with international partners"
  },
  {
    id: 2,
    role: "Head of Industry Events",
    company: "Red Sea International Film Festival",
    location: "Jeddah, Saudi Arabia",
    period: "2022 - 2023",
    description: "Directed 15+ annual industry events hosting 60+ international speakers"
  },
  {
    id: 3,
    role: "Senior International Coordinator",
    company: "Ajyal & Doha Film Festival",
    location: "Doha, Qatar",
    period: "2024 - 2025",
    description: "Oversaw international Jury Programme and festival content coordination"
  },
  {
    id: 4,
    role: "Creative Director & Event Strategist",
    company: "Freelance Consultant",
    location: "International",
    period: "2019 - Present",
    description: "Strategic storytelling and creative R&D for Air France, Cirque du Soleil, and more"
  }
];

export const education = [
  {
    degree: "MSc Media Management",
    institution: "ESCP Europe",
    location: "Paris",
    year: "2020-2021",
    distinction: "With Jury Distinction"
  },
  {
    degree: "Masters in Event Management",
    institution: "Istituto Europeo di Design",
    location: "Milan",
    year: "2014-2015"
  },
  {
    degree: "B.A. Dramatic Arts",
    institution: "Cours Florent",
    location: "Paris",
    year: "2008-2011"
  }
];

export const languages = [
  { language: "French", level: "Native" },
  { language: "Arabic", level: "Native" },
  { language: "English", level: "C2 Professional" },
  { language: "Italian", level: "C2 Professional" },
  { language: "Spanish", level: "B1 Working Proficiency" }
];

export const insights = [
  {
    id: 1,
    title: "From Script to Screen: Navigating Film Development in International Markets",
    excerpt: "Insights from leading development at Cinemoz Media Group—structuring financing dossiers, coordinating pitch materials, and building co-production opportunities across borders.",
    date: "March 2024",
    readTime: "6 min read"
  },
  {
    id: 2,
    title: "Producing Industry Events That Matter: Lessons from Red Sea Film Festival",
    excerpt: "How strategic event production, content creation, and creative direction transformed the Red Sea Souk into a premier industry destination hosting 120+ experts annually.",
    date: "February 2024",
    readTime: "5 min read"
  },
  {
    id: 3,
    title: "Live Production at Scale: Managing High-Stakes Events from UEFA to National Ceremonies",
    excerpt: "Behind-the-scenes of producing opening ceremonies for UEFA Champions League, Euro 2016, and FIFA World Cup—coordinating multi-stakeholder environments under tight timelines.",
    date: "January 2024",
    readTime: "7 min read"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Festival Director",
    role: "Red Sea International Film Festival",
    company: "Red Sea Film Foundation",
    quote: "Carol's strategic vision and execution excellence elevated our industry programming. Her ability to manage complex events with 60+ speakers while maintaining brand alignment is exceptional."
  },
  {
    id: 2,
    name: "Production Partner",
    role: "International Event Production",
    company: "Major Sports Organization",
    quote: "Working with Carol on UEFA and FIFA ceremonies showed her mastery of large-scale live productions. She delivers under pressure with creative excellence and flawless coordination."
  }
];

export const notableClients = [
  "Red Sea International Film Festival",
  "Doha Film Institute",
  "Cinemoz Media Group",
  "Saudi Film Commission",
  "UEFA",
  "FIFA",
  "Filmmaster Events",
  "Balich Wonder Studio",
  "Air France",
  "Cirque du Soleil",
  "Initiative Film"
];

// Collaborations data

export const collaborations = [
  {
    category: "Live Events, Experiential & Creative Production",
    clients: [
      { name: "Acciona Events", country: "Spain, United Arab Emirates", website: "https://www.acciona.com", logo: "https://www.google.com/s2/favicons?domain=acciona.com&sz=128" },
      { name: "Balich Wonder Studio", country: "Italy, Saudi Arabia", website: "https://www.balichwonderstudio.com/", logo: "https://www.google.com/s2/favicons?domain=balichwonderstudio.com&sz=128" },
      { name: "Black Engineering", country: "Italy, United Arab Emirates", website: "https://blackengineering.com/", logo: "https://www.google.com/s2/favicons?domain=blackengineering.com&sz=128" },
      { name: "Broadway Entertainment Group", country: "United Arab Emirates", website: "https://www.broadwayentertainmentgroup.com/", logo: "https://www.google.com/s2/favicons?domain=broadwayentertainmentgroup.com&sz=128" },
      { name: "Cirque du Soleil", country: "Canada", website: "https://www.cirquedusoleil.com", logo: "https://www.google.com/s2/favicons?domain=cirquedusoleil.com&sz=128" },
      { name: "Clay TV", country: "Italy", website: "https://www.clay.tv/", logo: "https://www.google.com/s2/favicons?domain=clay.tv&sz=128" },
      { name: "Enso", country: "Saudi Arabia", website: "https://enso.sa/", logo: "https://www.google.com/s2/favicons?domain=enso.sa&sz=128" },
      { name: "Expand Expo", country: "Saudi Arabia", website: "https://home.expandexpo.com/", logo: "https://www.google.com/s2/favicons?domain=expandexpo.com&sz=128" },
      { name: "Foll'ia", country: "Italy", website: "", logo: "" },
      { name: "Filmmaster Events", country: "Italy", website: "https://www.filmmasterevents.com", logo: "https://www.google.com/s2/favicons?domain=filmmasterevents.com&sz=128" },
      { name: "Giò Forma", country: "Italy", website: "https://www.gioforma.com/en/home-page/", logo: "https://www.google.com/s2/favicons?domain=gioforma.com&sz=128" },
      { name: "HQ Worldwide Shows", country: "United Arab Emirates", website: "https://www.hqws.com/", logo: "https://www.google.com/s2/favicons?domain=hqws.com&sz=128" },
      { name: "Playfield Studio", country: "France", website: "https://playfield.studio/", logo: "https://www.google.com/s2/favicons?domain=playfield.studio&sz=128" },
      { name: "Time Entertainment", country: "Saudi Arabia", website: "https://www.time-entertainment.com/", logo: "https://www.google.com/s2/favicons?domain=time-entertainment.com&sz=128" },
      { name: "Richard Attias & Associates", country: "Saudi Arabia", website: "https://richardattiasassociates.com/en", logo: "https://www.google.com/s2/favicons?domain=richardattiasassociates.com&sz=128" }
    ]
  },
  {
    category: "Film Festivals & Markets",
    clients: [
      { name: "Ajyal Film Festival", country: "Qatar", website: "chrome-extension://efaidnbmnnnibpcajpcglclefindmkaj/https://media.dohafilm.com/sites/default/files/prod/2025-04/Ajyal2024FilmCatalogue-En.pdf", logo: "https://www.google.com/s2/favicons?domain=dohafilminstitute.com&sz=128" },
      { name: "Beirut International Women Film Festival", country: "Lebanon", website: "https://beirutwomenfilmfestival.com/", logo: "https://www.google.com/s2/favicons?domain=beirutwomenfilmfestival.com&sz=128" },
      { name: "CINEMED", country: "France", website: "https://www.cinemed.tm.fr/", logo: "https://www.google.com/s2/favicons?domain=cinemed.tm.fr&sz=128" },
      { name: "Doha Film Festival", country: "Qatar", website: "https://www.dohafilm.com/en/watch-discover/dff", logo: "https://www.google.com/s2/favicons?domain=dohafilm.com&sz=128" },
      { name: "Latin Arab International Film Festival", country: "Argentina", website: "", logo: "" },
      { name: "Lebanese Film Festival", country: "Lebanon", website: "https://www.lebanesefilmfestival.org/", logo: "https://www.google.com/s2/favicons?domain=lebanesefilmfestival.org&sz=128" },
      { name: "Manarat", country: "Tunisia", website: "", logo: "" },
      { name: "Olhares Do Mediterrâneo", country: "Portugal", website: "https://www.olharesdomediterraneo.org/submissions-2026-submissoes/", logo: "https://www.google.com/s2/favicons?domain=olharesdomediterraneo.org&sz=128" },
      { name: "Red Sea International Film Festival - Red Sea Souk", country: "Saudi Arabia", website: "https://www.redseafilmfest.com", logo: "https://www.google.com/s2/favicons?domain=redseafilmfest.com&sz=128" }
    ]
  },
  {
    category: "Film, TV & Audio-Visual",
    clients: [
      { name: "Attention O Chiens - AOC Production", country: "France", website: "https://www.aocprod.com/", logo: "https://www.google.com/s2/favicons?domain=aocprod.com&sz=128" },
      { name: "Cinemoz", country: "Lebanon", website: "", logo: "" },
      { name: "Cinephilia Productions", country: "USA", website: "https://www.cinephiliaproductions.com/", logo: "https://www.google.com/s2/favicons?domain=cinephiliaproductions.com&sz=128" },
      { name: "Dewberries Films", country: "France", website: "", logo: "" },
      { name: "The Project", country: "France", website: "http://theproject.paris/", logo: "https://www.google.com/s2/favicons?domain=theproject.paris&sz=128" },
      { name: "Initiative Film", country: "France", website: "", logo: "" },
      { name: "Né à Beyrouth Films", country: "Lebanon", website: "https://neabeyrouth.org/", logo: "https://www.google.com/s2/favicons?domain=neabeyrouth.org&sz=128" },
      { name: "CAA", country: "USA, UK", website: "https://www.caa.com", logo: "https://www.google.com/s2/favicons?domain=caa.com&sz=128" }
    ]
  },
  {
    category: "Cultural & Public Sector",
    clients: [
      { name: "Abu Dhabi Government Media Office", country: "United Arab Emirates", website: "https://www.mediaoffice.abudhabi", logo: "https://www.google.com/s2/favicons?domain=mediaoffice.abudhabi&sz=128" },
      { name: "Abu Dhabi Film Commission", country: "United Arab Emirates", website: "https://www.film.gov.ae/", logo: "https://www.google.com/s2/favicons?domain=film.gov.ae&sz=128" },
      { name: "Al Ula Film Commission", country: "Saudi Arabia", website: "https://filming.experiencealula.com/", logo: "https://www.google.com/s2/favicons?domain=experiencealula.com&sz=128" },
      { name: "Aquarium of Genoa", country: "Italy", website: "https://www.acquariodigenova.it", logo: "https://www.google.com/s2/favicons?domain=acquariodigenova.it&sz=128" },
      { name: "Diriyah Gate Development Authority", country: "Saudi Arabia", website: "https://www.diriyahcompany.sa/en", logo: "https://www.google.com/s2/favicons?domain=diriyahcompany.sa&sz=128" },
      { name: "Doha Film Institute", country: "Qatar", website: "https://www.dohafilminstitute.com", logo: "https://www.google.com/s2/favicons?domain=dohafilminstitute.com&sz=128" },
      { name: "Embassy of Argentina", country: "Lebanon", website: "https://www.cancilleria.gob.ar/", logo: "https://www.google.com/s2/favicons?domain=cancilleria.gob.ar&sz=128" },
      { name: "Fondation Liban Cinéma", country: "Lebanon", website: "https://fondationlibancinema.org/", logo: "https://www.google.com/s2/favicons?domain=fondationlibancinema.org&sz=128" },
      { name: "French Agency for Al Ula Development", country: "France, Saudi Arabia", website: "https://www.afalula.com", logo: "https://www.google.com/s2/favicons?domain=afalula.com&sz=128" },
      { name: "General Entertainment Authority", country: "Saudi Arabia", website: "https://gea.gov.sa", logo: "https://www.google.com/s2/favicons?domain=gea.gov.sa&sz=128" },
      { name: "Institut Français du Liban", country: "Lebanon", website: "https://www.institutfrancais-liban.com", logo: "https://www.google.com/s2/favicons?domain=institutfrancais-liban.com&sz=128" },
      { name: "La Cinémathèque Française", country: "France", website: "https://www.cinematheque.fr", logo: "https://www.google.com/s2/favicons?domain=cinematheque.fr&sz=128" },
      { name: "Ministry of Culture", country: "France", website: "https://www.culture.gouv.fr", logo: "https://www.google.com/s2/favicons?domain=culture.gouv.fr&sz=128" },
      { name: "Ministry of Culture", country: "Saudi Arabia", website: "https://www.moc.gov.sa", logo: "https://www.google.com/s2/favicons?domain=moc.gov.sa&sz=128" },
      { name: "Ministry of Tourism", country: "Saudi Arabia", website: "https://mt.gov.sa", logo: "https://www.google.com/s2/favicons?domain=mt.gov.sa&sz=128" },
      { name: "Organisation Internationale de la Francophonie", country: "France", website: "https://www.francophonie.org", logo: "https://www.google.com/s2/favicons?domain=francophonie.org&sz=128" },
      { name: "Red Sea Film Foundation", country: "Saudi Arabia", website: "https://www.redseafilmfest.com", logo: "https://www.google.com/s2/favicons?domain=redseafilmfest.com&sz=128" },
      { name: "Riyadh Art", country: "Saudi Arabia", website: "https://riyadhart.rcrc.gov.sa/en/", logo: "https://www.google.com/s2/favicons?domain=rcrc.gov.sa&sz=128" },
      { name: "Royal Commission for AlUla", country: "Saudi Arabia", website: "https://www.rcu.gov.sa", logo: "https://www.google.com/s2/favicons?domain=rcu.gov.sa&sz=128" },
      { name: "Saudi Film Commission", country: "Saudi Arabia", website: "https://film.moc.gov.sa/en", logo: "https://www.google.com/s2/favicons?domain=film.moc.gov.sa&sz=128" },
      { name: "Supreme Committee", country: "Qatar", website: "https://www.sc.qa/en", logo: "https://www.google.com/s2/favicons?domain=sc.qa&sz=128" },
      { name: "The Crown Prince Court", country: "United Arab Emirates - Abu Dhabi", website: "https://www.mediaoffice.abudhabi/en/topic/crown-princes-court-cpc/", logo: "https://www.google.com/s2/favicons?domain=mediaoffice.abudhabi&sz=128" },
      { name: "UEFA", country: "Switzerland", website: "https://www.uefa.com", logo: "https://www.google.com/s2/favicons?domain=uefa.com&sz=128" }
    ]
  },
  {
    category: "Media & Broadcasting",
    clients: [
      { name: "Al Jazeera", country: "Qatar", website: "https://www.aljazeera.com", logo: "https://www.google.com/s2/favicons?domain=aljazeera.com&sz=128" },
      { name: "BBC Arabic", country: "Lebanon", website: "https://www.bbc.com/arabic", logo: "https://www.google.com/s2/favicons?domain=bbc.com&sz=128" },
      { name: "CFRT", country: "France", website: "https://www.cfrt.tv", logo: "https://www.google.com/s2/favicons?domain=cfrt.tv&sz=128" },
      { name: "France TV Studios", country: "France", website: "https://francetvstudio.fr/", logo: "https://www.google.com/s2/favicons?domain=francetvstudio.fr&sz=128" },
      { name: "LBCI", country: "Lebanon", website: "https://www.lbcgroup.tv", logo: "https://www.google.com/s2/favicons?domain=lbcgroup.tv&sz=128" },
      { name: "Le Français dans le Monde", country: "France", website: "https://www.fdlm.org", logo: "https://www.google.com/s2/favicons?domain=fdlm.org&sz=128" },
      { name: "TV5 Monde", country: "France", website: "https://www.tv5monde.com", logo: "https://www.google.com/s2/favicons?domain=tv5monde.com&sz=128" }
    ]
  },
  {
    category: "Corporate & Brands",
    clients: [
      { name: "Air France", country: "Lebanon", website: "https://wwws.airfrance.com.lb/", logo: "https://www.google.com/s2/favicons?domain=airfrance.com.lb&sz=128" },
      { name: "Emile Rassam", country: "Lebanon", website: "https://emilerassam.com/", logo: "https://www.google.com/s2/favicons?domain=emilerassam.com&sz=128" },
      { name: "SAB Bank", country: "Saudi Arabia", website: "https://www.sab.com/en/personal/", logo: "https://www.google.com/s2/favicons?domain=sab.com&sz=128" },
      { name: "SURV Linguistics", country: "Lebanon, Dubai", website: "https://survlinguistics.com/", logo: "https://www.google.com/s2/favicons?domain=survlinguistics.com&sz=128" }
    ]
  }
];
